import { openBlock as $, createElementBlock as F, normalizeStyle as dr, createStaticVNode as gr, pushScopeId as pr, popScopeId as br, createElementVNode as M } from "vue";
function rr(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var yr = function(r) {
  var e = {};
  function a(n) {
    if (e[n])
      return e[n].exports;
    var t = e[n] = { i: n, l: !1, exports: {} };
    return r[n].call(t.exports, t, t.exports, a), t.l = !0, t.exports;
  }
  return a.m = r, a.c = e, a.d = function(n, t, i) {
    a.o(n, t) || Object.defineProperty(n, t, { enumerable: !0, get: i });
  }, a.r = function(n) {
    typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(n, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(n, "__esModule", { value: !0 });
  }, a.t = function(n, t) {
    if (1 & t && (n = a(n)), 8 & t || 4 & t && typeof n == "object" && n && n.__esModule)
      return n;
    var i = /* @__PURE__ */ Object.create(null);
    if (a.r(i), Object.defineProperty(i, "default", { enumerable: !0, value: n }), 2 & t && typeof n != "string")
      for (var o in n)
        a.d(i, o, (function(s) {
          return n[s];
        }).bind(null, o));
    return i;
  }, a.n = function(n) {
    var t = n && n.__esModule ? function() {
      return n.default;
    } : function() {
      return n;
    };
    return a.d(t, "a", t), t;
  }, a.o = function(n, t) {
    return Object.prototype.hasOwnProperty.call(n, t);
  }, a.p = "", a(a.s = 0);
}([function(r, e, a) {
  a.r(e), a.d(e, "validateHTMLColorName", function() {
    return o;
  }), a.d(e, "validateHTMLColorSpecialName", function() {
    return s;
  }), a.d(e, "validateHTMLColorHex", function() {
    return l;
  }), a.d(e, "validateHTMLColorRgb", function() {
    return q;
  }), a.d(e, "validateHTMLColorHsl", function() {
    return T;
  }), a.d(e, "validateHTMLColorHwb", function() {
    return R;
  }), a.d(e, "validateHTMLColorLab", function() {
    return N;
  }), a.d(e, "validateHTMLColorLch", function() {
    return H;
  }), a.d(e, "validateHTMLColor", function() {
    return hr;
  });
  const n = (c) => c && typeof c == "string", t = ["AliceBlue", "AntiqueWhite", "Aqua", "Aquamarine", "Azure", "Beige", "Bisque", "Black", "BlanchedAlmond", "Blue", "BlueViolet", "Brown", "BurlyWood", "CadetBlue", "Chartreuse", "Chocolate", "Coral", "CornflowerBlue", "Cornsilk", "Crimson", "Cyan", "DarkBlue", "DarkCyan", "DarkGoldenrod", "DarkGray", "DarkGrey", "DarkGreen", "DarkKhaki", "DarkMagenta", "DarkOliveGreen", "DarkOrange", "DarkOrchid", "DarkRed", "DarkSalmon", "DarkSeaGreen", "DarkSlateBlue", "DarkSlateGray", "DarkSlateGrey", "DarkTurquoise", "DarkViolet", "DeepPink", "DeepSkyBlue", "DimGray", "DimGrey", "DodgerBlue", "FireBrick", "FloralWhite", "ForestGreen", "Fuchsia", "Gainsboro", "GhostWhite", "Gold", "Goldenrod", "Gray", "Grey", "Green", "GreenYellow", "HoneyDew", "HotPink", "IndianRed", "Indigo", "Ivory", "Khaki", "Lavender", "LavenderBlush", "LawnGreen", "LemonChiffon", "LightBlue", "LightCoral", "LightCyan", "LightGoldenrodYellow", "LightGray", "LightGrey", "LightGreen", "LightPink", "LightSalmon", "LightSalmon", "LightSeaGreen", "LightSkyBlue", "LightSlateGray", "LightSlateGrey", "LightSteelBlue", "LightYellow", "Lime", "LimeGreen", "Linen", "Magenta", "Maroon", "MediumAquamarine", "MediumBlue", "MediumOrchid", "MediumPurple", "MediumSeaGreen", "MediumSlateBlue", "MediumSlateBlue", "MediumSpringGreen", "MediumTurquoise", "MediumVioletRed", "MidnightBlue", "MintCream", "MistyRose", "Moccasin", "NavajoWhite", "Navy", "OldLace", "Olive", "OliveDrab", "Orange", "OrangeRed", "Orchid", "PaleGoldenrod", "PaleGreen", "PaleTurquoise", "PaleVioletRed", "PapayaWhip", "PeachPuff", "Peru", "Pink", "Plum", "PowderBlue", "Purple", "RebeccaPurple", "Red", "RosyBrown", "RoyalBlue", "SaddleBrown", "Salmon", "SandyBrown", "SeaGreen", "SeaShell", "Sienna", "Silver", "SkyBlue", "SlateBlue", "SlateGray", "SlateGrey", "Snow", "SpringGreen", "SteelBlue", "Tan", "Teal", "Thistle", "Tomato", "Turquoise", "Violet", "Wheat", "White", "WhiteSmoke", "Yellow", "YellowGreen"], i = ["currentColor", "inherit", "transparent"], o = (c) => {
    let g = !1;
    return n(c) && t.map((k) => (c.toLowerCase() === k.toLowerCase() && (g = !0), null)), g;
  }, s = (c) => {
    let g = !1;
    return n(c) && i.map((k) => (c.toLowerCase() === k.toLowerCase() && (g = !0), null)), g;
  }, l = (c) => n(c) ? c && /^#([\da-f]{3}){1,2}$|^#([\da-f]{4}){1,2}$/i.test(c) : !1, h = "(([\\d]{0,5})((\\.([\\d]{1,5}))?))", f = `(${h}%)`, d = "(([0-9]|[1-9][0-9]|100)%)", B = `(${d}|(0?((\\.([\\d]{1,5}))?))|1)`, Q = `([\\s]{0,5})\\)?)(([\\s]{0,5})(\\/?)([\\s]{1,5})${`(((${d}))|(0?((\\.([\\d]{1,5}))?))|1))?`}([\\s]{0,5})\\)`, I = "(-?(([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-9][0-9]|3[0-5][0-9])((\\.([\\d]{1,5}))?)|360)(deg)?)", q = (c) => {
    if (n(c)) {
      const g = "([\\s]{0,5})([\\d]{1,5})%?([\\s]{0,5}),?", k = "((([\\s]{0,5}),?([\\s]{0,5}))|(([\\s]{1,5})))", V = new RegExp(`^(rgb)a?\\(${`${g}${k}`}${`${g}${k}`}${`${g}${k}`}((\\/?([\\s]{0,5})(0?\\.?([\\d]{1,5})%?([\\s]{0,5}))?|1|0))?\\)$`);
      return c && V.test(c);
    }
    return !1;
  }, T = (c) => {
    if (n(c)) {
      const g = new RegExp(`^(hsl)a?\\((([\\s]{0,5})(${I}|(([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-9][0-9]|3[0-9][0-9]|400)grad)|((([0-5])?\\.([\\d]{1,5})|6\\.([0-9]|1[0-9]|2[0-8])|[0-6])rad)|((0?((\\.([\\d]{1,5}))?)|1)turn))((([\\s]{0,5}),([\\s]{0,5}))|(([\\s]{1,5}))))(([\\s]{0,5})(0|${d})((([\\s]{0,5}),([\\s]{0,5}))|(([\\s]{1,5}))))(([\\s]{0,5})(0|${d})([\\s]{0,5})\\)?)(([\\s]{0,5})(\\/?|,?)([\\s]{0,5})(((${d}))|(0?((\\.([\\d]{1,5}))?))|1))?\\)$`);
      return c && g.test(c);
    }
    return !1;
  }, R = (c) => {
    if (n(c)) {
      const g = new RegExp(`^(hwb\\(([\\s]{0,5})${I}([\\s]{1,5}))((0|${d})([\\s]{1,5}))((0|${d})${Q}$`);
      return c && g.test(c);
    }
    return !1;
  }, N = (c) => {
    if (n(c)) {
      const g = "(-?(([0-9]|[1-9][0-9]|1[0-5][0-9])((\\.([\\d]{1,5}))?)?|160))", k = new RegExp(`^(lab\\(([\\s]{0,5})${f}([\\s]{1,5})${g}([\\s]{1,5})${g}${Q}$`);
      return c && k.test(c);
    }
    return !1;
  }, H = (c) => {
    if (n(c)) {
      const g = "((([0-9]|[1-9][0-9])?((\\.([\\d]{1,5}))?)|100)(%)?)", k = "" + h, V = `((${I})|(0|${B})|(([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-9][0-9]|3[0-5][0-9])((\\.([\\d]{1,5}))?)|360))`, vr = `(\\/([\\s]{0,5})${B})`, fr = new RegExp(`^lch\\(${`(([\\s]{0,5})${g}([\\s]{1,5})${k}([\\s]{1,5})${V}([\\s]{0,5})(${vr})?)`}\\)$`);
      return c && fr.test(c);
    }
    return !1;
  }, hr = (c) => !!(c && l(c) || q(c) || T(c) || R(c) || N(c) || H(c));
  e.default = (c) => !!(c && l(c) || o(c) || s(c) || q(c) || T(c) || R(c) || N(c) || H(c));
}]);
const X = /* @__PURE__ */ rr(yr);
var er = { exports: {} }, ar = {
  aliceblue: [240, 248, 255],
  antiquewhite: [250, 235, 215],
  aqua: [0, 255, 255],
  aquamarine: [127, 255, 212],
  azure: [240, 255, 255],
  beige: [245, 245, 220],
  bisque: [255, 228, 196],
  black: [0, 0, 0],
  blanchedalmond: [255, 235, 205],
  blue: [0, 0, 255],
  blueviolet: [138, 43, 226],
  brown: [165, 42, 42],
  burlywood: [222, 184, 135],
  cadetblue: [95, 158, 160],
  chartreuse: [127, 255, 0],
  chocolate: [210, 105, 30],
  coral: [255, 127, 80],
  cornflowerblue: [100, 149, 237],
  cornsilk: [255, 248, 220],
  crimson: [220, 20, 60],
  cyan: [0, 255, 255],
  darkblue: [0, 0, 139],
  darkcyan: [0, 139, 139],
  darkgoldenrod: [184, 134, 11],
  darkgray: [169, 169, 169],
  darkgreen: [0, 100, 0],
  darkgrey: [169, 169, 169],
  darkkhaki: [189, 183, 107],
  darkmagenta: [139, 0, 139],
  darkolivegreen: [85, 107, 47],
  darkorange: [255, 140, 0],
  darkorchid: [153, 50, 204],
  darkred: [139, 0, 0],
  darksalmon: [233, 150, 122],
  darkseagreen: [143, 188, 143],
  darkslateblue: [72, 61, 139],
  darkslategray: [47, 79, 79],
  darkslategrey: [47, 79, 79],
  darkturquoise: [0, 206, 209],
  darkviolet: [148, 0, 211],
  deeppink: [255, 20, 147],
  deepskyblue: [0, 191, 255],
  dimgray: [105, 105, 105],
  dimgrey: [105, 105, 105],
  dodgerblue: [30, 144, 255],
  firebrick: [178, 34, 34],
  floralwhite: [255, 250, 240],
  forestgreen: [34, 139, 34],
  fuchsia: [255, 0, 255],
  gainsboro: [220, 220, 220],
  ghostwhite: [248, 248, 255],
  gold: [255, 215, 0],
  goldenrod: [218, 165, 32],
  gray: [128, 128, 128],
  green: [0, 128, 0],
  greenyellow: [173, 255, 47],
  grey: [128, 128, 128],
  honeydew: [240, 255, 240],
  hotpink: [255, 105, 180],
  indianred: [205, 92, 92],
  indigo: [75, 0, 130],
  ivory: [255, 255, 240],
  khaki: [240, 230, 140],
  lavender: [230, 230, 250],
  lavenderblush: [255, 240, 245],
  lawngreen: [124, 252, 0],
  lemonchiffon: [255, 250, 205],
  lightblue: [173, 216, 230],
  lightcoral: [240, 128, 128],
  lightcyan: [224, 255, 255],
  lightgoldenrodyellow: [250, 250, 210],
  lightgray: [211, 211, 211],
  lightgreen: [144, 238, 144],
  lightgrey: [211, 211, 211],
  lightpink: [255, 182, 193],
  lightsalmon: [255, 160, 122],
  lightseagreen: [32, 178, 170],
  lightskyblue: [135, 206, 250],
  lightslategray: [119, 136, 153],
  lightslategrey: [119, 136, 153],
  lightsteelblue: [176, 196, 222],
  lightyellow: [255, 255, 224],
  lime: [0, 255, 0],
  limegreen: [50, 205, 50],
  linen: [250, 240, 230],
  magenta: [255, 0, 255],
  maroon: [128, 0, 0],
  mediumaquamarine: [102, 205, 170],
  mediumblue: [0, 0, 205],
  mediumorchid: [186, 85, 211],
  mediumpurple: [147, 112, 219],
  mediumseagreen: [60, 179, 113],
  mediumslateblue: [123, 104, 238],
  mediumspringgreen: [0, 250, 154],
  mediumturquoise: [72, 209, 204],
  mediumvioletred: [199, 21, 133],
  midnightblue: [25, 25, 112],
  mintcream: [245, 255, 250],
  mistyrose: [255, 228, 225],
  moccasin: [255, 228, 181],
  navajowhite: [255, 222, 173],
  navy: [0, 0, 128],
  oldlace: [253, 245, 230],
  olive: [128, 128, 0],
  olivedrab: [107, 142, 35],
  orange: [255, 165, 0],
  orangered: [255, 69, 0],
  orchid: [218, 112, 214],
  palegoldenrod: [238, 232, 170],
  palegreen: [152, 251, 152],
  paleturquoise: [175, 238, 238],
  palevioletred: [219, 112, 147],
  papayawhip: [255, 239, 213],
  peachpuff: [255, 218, 185],
  peru: [205, 133, 63],
  pink: [255, 192, 203],
  plum: [221, 160, 221],
  powderblue: [176, 224, 230],
  purple: [128, 0, 128],
  rebeccapurple: [102, 51, 153],
  red: [255, 0, 0],
  rosybrown: [188, 143, 143],
  royalblue: [65, 105, 225],
  saddlebrown: [139, 69, 19],
  salmon: [250, 128, 114],
  sandybrown: [244, 164, 96],
  seagreen: [46, 139, 87],
  seashell: [255, 245, 238],
  sienna: [160, 82, 45],
  silver: [192, 192, 192],
  skyblue: [135, 206, 235],
  slateblue: [106, 90, 205],
  slategray: [112, 128, 144],
  slategrey: [112, 128, 144],
  snow: [255, 250, 250],
  springgreen: [0, 255, 127],
  steelblue: [70, 130, 180],
  tan: [210, 180, 140],
  teal: [0, 128, 128],
  thistle: [216, 191, 216],
  tomato: [255, 99, 71],
  turquoise: [64, 224, 208],
  violet: [238, 130, 238],
  wheat: [245, 222, 179],
  white: [255, 255, 255],
  whitesmoke: [245, 245, 245],
  yellow: [255, 255, 0],
  yellowgreen: [154, 205, 50]
}, nr = { exports: {} }, mr = function(e) {
  return !e || typeof e == "string" ? !1 : e instanceof Array || Array.isArray(e) || e.length >= 0 && (e.splice instanceof Function || Object.getOwnPropertyDescriptor(e, e.length - 1) && e.constructor.name !== "String");
}, wr = mr, kr = Array.prototype.concat, Mr = Array.prototype.slice, Z = nr.exports = function(e) {
  for (var a = [], n = 0, t = e.length; n < t; n++) {
    var i = e[n];
    wr(i) ? a = kr.call(a, Mr.call(i)) : a.push(i);
  }
  return a;
};
Z.wrap = function(r) {
  return function() {
    return r(Z(arguments));
  };
};
var xr = nr.exports, C = ar, G = xr, tr = Object.hasOwnProperty, or = /* @__PURE__ */ Object.create(null);
for (var W in C)
  tr.call(C, W) && (or[C[W]] = W);
var w = er.exports = {
  to: {},
  get: {}
};
w.get = function(r) {
  var e = r.substring(0, 3).toLowerCase(), a, n;
  switch (e) {
    case "hsl":
      a = w.get.hsl(r), n = "hsl";
      break;
    case "hwb":
      a = w.get.hwb(r), n = "hwb";
      break;
    default:
      a = w.get.rgb(r), n = "rgb";
      break;
  }
  return a ? { model: n, value: a } : null;
};
w.get.rgb = function(r) {
  if (!r)
    return null;
  var e = /^#([a-f0-9]{3,4})$/i, a = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i, n = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/, t = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/, i = /^(\w+)$/, o = [0, 0, 0, 1], s, l, h;
  if (s = r.match(a)) {
    for (h = s[2], s = s[1], l = 0; l < 3; l++) {
      var f = l * 2;
      o[l] = parseInt(s.slice(f, f + 2), 16);
    }
    h && (o[3] = parseInt(h, 16) / 255);
  } else if (s = r.match(e)) {
    for (s = s[1], h = s[3], l = 0; l < 3; l++)
      o[l] = parseInt(s[l] + s[l], 16);
    h && (o[3] = parseInt(h + h, 16) / 255);
  } else if (s = r.match(n)) {
    for (l = 0; l < 3; l++)
      o[l] = parseInt(s[l + 1], 0);
    s[4] && (s[5] ? o[3] = parseFloat(s[4]) * 0.01 : o[3] = parseFloat(s[4]));
  } else if (s = r.match(t)) {
    for (l = 0; l < 3; l++)
      o[l] = Math.round(parseFloat(s[l + 1]) * 2.55);
    s[4] && (s[5] ? o[3] = parseFloat(s[4]) * 0.01 : o[3] = parseFloat(s[4]));
  } else
    return (s = r.match(i)) ? s[1] === "transparent" ? [0, 0, 0, 0] : tr.call(C, s[1]) ? (o = C[s[1]], o[3] = 1, o) : null : null;
  for (l = 0; l < 3; l++)
    o[l] = _(o[l], 0, 255);
  return o[3] = _(o[3], 0, 1), o;
};
w.get.hsl = function(r) {
  if (!r)
    return null;
  var e = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/, a = r.match(e);
  if (a) {
    var n = parseFloat(a[4]), t = (parseFloat(a[1]) % 360 + 360) % 360, i = _(parseFloat(a[2]), 0, 100), o = _(parseFloat(a[3]), 0, 100), s = _(isNaN(n) ? 1 : n, 0, 1);
    return [t, i, o, s];
  }
  return null;
};
w.get.hwb = function(r) {
  if (!r)
    return null;
  var e = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/, a = r.match(e);
  if (a) {
    var n = parseFloat(a[4]), t = (parseFloat(a[1]) % 360 + 360) % 360, i = _(parseFloat(a[2]), 0, 100), o = _(parseFloat(a[3]), 0, 100), s = _(isNaN(n) ? 1 : n, 0, 1);
    return [t, i, o, s];
  }
  return null;
};
w.to.hex = function() {
  var r = G(arguments);
  return "#" + D(r[0]) + D(r[1]) + D(r[2]) + (r[3] < 1 ? D(Math.round(r[3] * 255)) : "");
};
w.to.rgb = function() {
  var r = G(arguments);
  return r.length < 4 || r[3] === 1 ? "rgb(" + Math.round(r[0]) + ", " + Math.round(r[1]) + ", " + Math.round(r[2]) + ")" : "rgba(" + Math.round(r[0]) + ", " + Math.round(r[1]) + ", " + Math.round(r[2]) + ", " + r[3] + ")";
};
w.to.rgb.percent = function() {
  var r = G(arguments), e = Math.round(r[0] / 255 * 100), a = Math.round(r[1] / 255 * 100), n = Math.round(r[2] / 255 * 100);
  return r.length < 4 || r[3] === 1 ? "rgb(" + e + "%, " + a + "%, " + n + "%)" : "rgba(" + e + "%, " + a + "%, " + n + "%, " + r[3] + ")";
};
w.to.hsl = function() {
  var r = G(arguments);
  return r.length < 4 || r[3] === 1 ? "hsl(" + r[0] + ", " + r[1] + "%, " + r[2] + "%)" : "hsla(" + r[0] + ", " + r[1] + "%, " + r[2] + "%, " + r[3] + ")";
};
w.to.hwb = function() {
  var r = G(arguments), e = "";
  return r.length >= 4 && r[3] !== 1 && (e = ", " + r[3]), "hwb(" + r[0] + ", " + r[1] + "%, " + r[2] + "%" + e + ")";
};
w.to.keyword = function(r) {
  return or[r.slice(0, 3)];
};
function _(r, e, a) {
  return Math.min(Math.max(e, r), a);
}
function D(r) {
  var e = Math.round(r).toString(16).toUpperCase();
  return e.length < 2 ? "0" + e : e;
}
var _r = er.exports, ir = { exports: {} }, S = ar, sr = {};
for (var U in S)
  S.hasOwnProperty(U) && (sr[S[U]] = U);
var u = ir.exports = {
  rgb: { channels: 3, labels: "rgb" },
  hsl: { channels: 3, labels: "hsl" },
  hsv: { channels: 3, labels: "hsv" },
  hwb: { channels: 3, labels: "hwb" },
  cmyk: { channels: 4, labels: "cmyk" },
  xyz: { channels: 3, labels: "xyz" },
  lab: { channels: 3, labels: "lab" },
  lch: { channels: 3, labels: "lch" },
  hex: { channels: 1, labels: ["hex"] },
  keyword: { channels: 1, labels: ["keyword"] },
  ansi16: { channels: 1, labels: ["ansi16"] },
  ansi256: { channels: 1, labels: ["ansi256"] },
  hcg: { channels: 3, labels: ["h", "c", "g"] },
  apple: { channels: 3, labels: ["r16", "g16", "b16"] },
  gray: { channels: 1, labels: ["gray"] }
};
for (var y in u)
  if (u.hasOwnProperty(y)) {
    if (!("channels" in u[y]))
      throw new Error("missing channels property: " + y);
    if (!("labels" in u[y]))
      throw new Error("missing channel labels property: " + y);
    if (u[y].labels.length !== u[y].channels)
      throw new Error("channel and label counts mismatch: " + y);
    var Sr = u[y].channels, $r = u[y].labels;
    delete u[y].channels, delete u[y].labels, Object.defineProperty(u[y], "channels", { value: Sr }), Object.defineProperty(u[y], "labels", { value: $r });
  }
u.rgb.hsl = function(r) {
  var e = r[0] / 255, a = r[1] / 255, n = r[2] / 255, t = Math.min(e, a, n), i = Math.max(e, a, n), o = i - t, s, l, h;
  return i === t ? s = 0 : e === i ? s = (a - n) / o : a === i ? s = 2 + (n - e) / o : n === i && (s = 4 + (e - a) / o), s = Math.min(s * 60, 360), s < 0 && (s += 360), h = (t + i) / 2, i === t ? l = 0 : h <= 0.5 ? l = o / (i + t) : l = o / (2 - i - t), [s, l * 100, h * 100];
};
u.rgb.hsv = function(r) {
  var e, a, n, t, i, o = r[0] / 255, s = r[1] / 255, l = r[2] / 255, h = Math.max(o, s, l), f = h - Math.min(o, s, l), d = function(B) {
    return (h - B) / 6 / f + 1 / 2;
  };
  return f === 0 ? t = i = 0 : (i = f / h, e = d(o), a = d(s), n = d(l), o === h ? t = n - a : s === h ? t = 1 / 3 + e - n : l === h && (t = 2 / 3 + a - e), t < 0 ? t += 1 : t > 1 && (t -= 1)), [
    t * 360,
    i * 100,
    h * 100
  ];
};
u.rgb.hwb = function(r) {
  var e = r[0], a = r[1], n = r[2], t = u.rgb.hsl(r)[0], i = 1 / 255 * Math.min(e, Math.min(a, n));
  return n = 1 - 1 / 255 * Math.max(e, Math.max(a, n)), [t, i * 100, n * 100];
};
u.rgb.cmyk = function(r) {
  var e = r[0] / 255, a = r[1] / 255, n = r[2] / 255, t, i, o, s;
  return s = Math.min(1 - e, 1 - a, 1 - n), t = (1 - e - s) / (1 - s) || 0, i = (1 - a - s) / (1 - s) || 0, o = (1 - n - s) / (1 - s) || 0, [t * 100, i * 100, o * 100, s * 100];
};
function Fr(r, e) {
  return Math.pow(r[0] - e[0], 2) + Math.pow(r[1] - e[1], 2) + Math.pow(r[2] - e[2], 2);
}
u.rgb.keyword = function(r) {
  var e = sr[r];
  if (e)
    return e;
  var a = 1 / 0, n;
  for (var t in S)
    if (S.hasOwnProperty(t)) {
      var i = S[t], o = Fr(r, i);
      o < a && (a = o, n = t);
    }
  return n;
};
u.keyword.rgb = function(r) {
  return S[r];
};
u.rgb.xyz = function(r) {
  var e = r[0] / 255, a = r[1] / 255, n = r[2] / 255;
  e = e > 0.04045 ? Math.pow((e + 0.055) / 1.055, 2.4) : e / 12.92, a = a > 0.04045 ? Math.pow((a + 0.055) / 1.055, 2.4) : a / 12.92, n = n > 0.04045 ? Math.pow((n + 0.055) / 1.055, 2.4) : n / 12.92;
  var t = e * 0.4124 + a * 0.3576 + n * 0.1805, i = e * 0.2126 + a * 0.7152 + n * 0.0722, o = e * 0.0193 + a * 0.1192 + n * 0.9505;
  return [t * 100, i * 100, o * 100];
};
u.rgb.lab = function(r) {
  var e = u.rgb.xyz(r), a = e[0], n = e[1], t = e[2], i, o, s;
  return a /= 95.047, n /= 100, t /= 108.883, a = a > 8856e-6 ? Math.pow(a, 1 / 3) : 7.787 * a + 16 / 116, n = n > 8856e-6 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116, t = t > 8856e-6 ? Math.pow(t, 1 / 3) : 7.787 * t + 16 / 116, i = 116 * n - 16, o = 500 * (a - n), s = 200 * (n - t), [i, o, s];
};
u.hsl.rgb = function(r) {
  var e = r[0] / 360, a = r[1] / 100, n = r[2] / 100, t, i, o, s, l;
  if (a === 0)
    return l = n * 255, [l, l, l];
  n < 0.5 ? i = n * (1 + a) : i = n + a - n * a, t = 2 * n - i, s = [0, 0, 0];
  for (var h = 0; h < 3; h++)
    o = e + 1 / 3 * -(h - 1), o < 0 && o++, o > 1 && o--, 6 * o < 1 ? l = t + (i - t) * 6 * o : 2 * o < 1 ? l = i : 3 * o < 2 ? l = t + (i - t) * (2 / 3 - o) * 6 : l = t, s[h] = l * 255;
  return s;
};
u.hsl.hsv = function(r) {
  var e = r[0], a = r[1] / 100, n = r[2] / 100, t = a, i = Math.max(n, 0.01), o, s;
  return n *= 2, a *= n <= 1 ? n : 2 - n, t *= i <= 1 ? i : 2 - i, s = (n + a) / 2, o = n === 0 ? 2 * t / (i + t) : 2 * a / (n + a), [e, o * 100, s * 100];
};
u.hsv.rgb = function(r) {
  var e = r[0] / 60, a = r[1] / 100, n = r[2] / 100, t = Math.floor(e) % 6, i = e - Math.floor(e), o = 255 * n * (1 - a), s = 255 * n * (1 - a * i), l = 255 * n * (1 - a * (1 - i));
  switch (n *= 255, t) {
    case 0:
      return [n, l, o];
    case 1:
      return [s, n, o];
    case 2:
      return [o, n, l];
    case 3:
      return [o, s, n];
    case 4:
      return [l, o, n];
    case 5:
      return [n, o, s];
  }
};
u.hsv.hsl = function(r) {
  var e = r[0], a = r[1] / 100, n = r[2] / 100, t = Math.max(n, 0.01), i, o, s;
  return s = (2 - a) * n, i = (2 - a) * t, o = a * t, o /= i <= 1 ? i : 2 - i, o = o || 0, s /= 2, [e, o * 100, s * 100];
};
u.hwb.rgb = function(r) {
  var e = r[0] / 360, a = r[1] / 100, n = r[2] / 100, t = a + n, i, o, s, l;
  t > 1 && (a /= t, n /= t), i = Math.floor(6 * e), o = 1 - n, s = 6 * e - i, i & 1 && (s = 1 - s), l = a + s * (o - a);
  var h, f, d;
  switch (i) {
    default:
    case 6:
    case 0:
      h = o, f = l, d = a;
      break;
    case 1:
      h = l, f = o, d = a;
      break;
    case 2:
      h = a, f = o, d = l;
      break;
    case 3:
      h = a, f = l, d = o;
      break;
    case 4:
      h = l, f = a, d = o;
      break;
    case 5:
      h = o, f = a, d = l;
      break;
  }
  return [h * 255, f * 255, d * 255];
};
u.cmyk.rgb = function(r) {
  var e = r[0] / 100, a = r[1] / 100, n = r[2] / 100, t = r[3] / 100, i, o, s;
  return i = 1 - Math.min(1, e * (1 - t) + t), o = 1 - Math.min(1, a * (1 - t) + t), s = 1 - Math.min(1, n * (1 - t) + t), [i * 255, o * 255, s * 255];
};
u.xyz.rgb = function(r) {
  var e = r[0] / 100, a = r[1] / 100, n = r[2] / 100, t, i, o;
  return t = e * 3.2406 + a * -1.5372 + n * -0.4986, i = e * -0.9689 + a * 1.8758 + n * 0.0415, o = e * 0.0557 + a * -0.204 + n * 1.057, t = t > 31308e-7 ? 1.055 * Math.pow(t, 1 / 2.4) - 0.055 : t * 12.92, i = i > 31308e-7 ? 1.055 * Math.pow(i, 1 / 2.4) - 0.055 : i * 12.92, o = o > 31308e-7 ? 1.055 * Math.pow(o, 1 / 2.4) - 0.055 : o * 12.92, t = Math.min(Math.max(0, t), 1), i = Math.min(Math.max(0, i), 1), o = Math.min(Math.max(0, o), 1), [t * 255, i * 255, o * 255];
};
u.xyz.lab = function(r) {
  var e = r[0], a = r[1], n = r[2], t, i, o;
  return e /= 95.047, a /= 100, n /= 108.883, e = e > 8856e-6 ? Math.pow(e, 1 / 3) : 7.787 * e + 16 / 116, a = a > 8856e-6 ? Math.pow(a, 1 / 3) : 7.787 * a + 16 / 116, n = n > 8856e-6 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116, t = 116 * a - 16, i = 500 * (e - a), o = 200 * (a - n), [t, i, o];
};
u.lab.xyz = function(r) {
  var e = r[0], a = r[1], n = r[2], t, i, o;
  i = (e + 16) / 116, t = a / 500 + i, o = i - n / 200;
  var s = Math.pow(i, 3), l = Math.pow(t, 3), h = Math.pow(o, 3);
  return i = s > 8856e-6 ? s : (i - 16 / 116) / 7.787, t = l > 8856e-6 ? l : (t - 16 / 116) / 7.787, o = h > 8856e-6 ? h : (o - 16 / 116) / 7.787, t *= 95.047, i *= 100, o *= 108.883, [t, i, o];
};
u.lab.lch = function(r) {
  var e = r[0], a = r[1], n = r[2], t, i, o;
  return t = Math.atan2(n, a), i = t * 360 / 2 / Math.PI, i < 0 && (i += 360), o = Math.sqrt(a * a + n * n), [e, o, i];
};
u.lch.lab = function(r) {
  var e = r[0], a = r[1], n = r[2], t, i, o;
  return o = n / 360 * 2 * Math.PI, t = a * Math.cos(o), i = a * Math.sin(o), [e, t, i];
};
u.rgb.ansi16 = function(r) {
  var e = r[0], a = r[1], n = r[2], t = 1 in arguments ? arguments[1] : u.rgb.hsv(r)[2];
  if (t = Math.round(t / 50), t === 0)
    return 30;
  var i = 30 + (Math.round(n / 255) << 2 | Math.round(a / 255) << 1 | Math.round(e / 255));
  return t === 2 && (i += 60), i;
};
u.hsv.ansi16 = function(r) {
  return u.rgb.ansi16(u.hsv.rgb(r), r[2]);
};
u.rgb.ansi256 = function(r) {
  var e = r[0], a = r[1], n = r[2];
  if (e === a && a === n)
    return e < 8 ? 16 : e > 248 ? 231 : Math.round((e - 8) / 247 * 24) + 232;
  var t = 16 + 36 * Math.round(e / 255 * 5) + 6 * Math.round(a / 255 * 5) + Math.round(n / 255 * 5);
  return t;
};
u.ansi16.rgb = function(r) {
  var e = r % 10;
  if (e === 0 || e === 7)
    return r > 50 && (e += 3.5), e = e / 10.5 * 255, [e, e, e];
  var a = (~~(r > 50) + 1) * 0.5, n = (e & 1) * a * 255, t = (e >> 1 & 1) * a * 255, i = (e >> 2 & 1) * a * 255;
  return [n, t, i];
};
u.ansi256.rgb = function(r) {
  if (r >= 232) {
    var e = (r - 232) * 10 + 8;
    return [e, e, e];
  }
  r -= 16;
  var a, n = Math.floor(r / 36) / 5 * 255, t = Math.floor((a = r % 36) / 6) / 5 * 255, i = a % 6 / 5 * 255;
  return [n, t, i];
};
u.rgb.hex = function(r) {
  var e = ((Math.round(r[0]) & 255) << 16) + ((Math.round(r[1]) & 255) << 8) + (Math.round(r[2]) & 255), a = e.toString(16).toUpperCase();
  return "000000".substring(a.length) + a;
};
u.hex.rgb = function(r) {
  var e = r.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
  if (!e)
    return [0, 0, 0];
  var a = e[0];
  e[0].length === 3 && (a = a.split("").map(function(s) {
    return s + s;
  }).join(""));
  var n = parseInt(a, 16), t = n >> 16 & 255, i = n >> 8 & 255, o = n & 255;
  return [t, i, o];
};
u.rgb.hcg = function(r) {
  var e = r[0] / 255, a = r[1] / 255, n = r[2] / 255, t = Math.max(Math.max(e, a), n), i = Math.min(Math.min(e, a), n), o = t - i, s, l;
  return o < 1 ? s = i / (1 - o) : s = 0, o <= 0 ? l = 0 : t === e ? l = (a - n) / o % 6 : t === a ? l = 2 + (n - e) / o : l = 4 + (e - a) / o + 4, l /= 6, l %= 1, [l * 360, o * 100, s * 100];
};
u.hsl.hcg = function(r) {
  var e = r[1] / 100, a = r[2] / 100, n = 1, t = 0;
  return a < 0.5 ? n = 2 * e * a : n = 2 * e * (1 - a), n < 1 && (t = (a - 0.5 * n) / (1 - n)), [r[0], n * 100, t * 100];
};
u.hsv.hcg = function(r) {
  var e = r[1] / 100, a = r[2] / 100, n = e * a, t = 0;
  return n < 1 && (t = (a - n) / (1 - n)), [r[0], n * 100, t * 100];
};
u.hcg.rgb = function(r) {
  var e = r[0] / 360, a = r[1] / 100, n = r[2] / 100;
  if (a === 0)
    return [n * 255, n * 255, n * 255];
  var t = [0, 0, 0], i = e % 1 * 6, o = i % 1, s = 1 - o, l = 0;
  switch (Math.floor(i)) {
    case 0:
      t[0] = 1, t[1] = o, t[2] = 0;
      break;
    case 1:
      t[0] = s, t[1] = 1, t[2] = 0;
      break;
    case 2:
      t[0] = 0, t[1] = 1, t[2] = o;
      break;
    case 3:
      t[0] = 0, t[1] = s, t[2] = 1;
      break;
    case 4:
      t[0] = o, t[1] = 0, t[2] = 1;
      break;
    default:
      t[0] = 1, t[1] = 0, t[2] = s;
  }
  return l = (1 - a) * n, [
    (a * t[0] + l) * 255,
    (a * t[1] + l) * 255,
    (a * t[2] + l) * 255
  ];
};
u.hcg.hsv = function(r) {
  var e = r[1] / 100, a = r[2] / 100, n = e + a * (1 - e), t = 0;
  return n > 0 && (t = e / n), [r[0], t * 100, n * 100];
};
u.hcg.hsl = function(r) {
  var e = r[1] / 100, a = r[2] / 100, n = a * (1 - e) + 0.5 * e, t = 0;
  return n > 0 && n < 0.5 ? t = e / (2 * n) : n >= 0.5 && n < 1 && (t = e / (2 * (1 - n))), [r[0], t * 100, n * 100];
};
u.hcg.hwb = function(r) {
  var e = r[1] / 100, a = r[2] / 100, n = e + a * (1 - e);
  return [r[0], (n - e) * 100, (1 - n) * 100];
};
u.hwb.hcg = function(r) {
  var e = r[1] / 100, a = r[2] / 100, n = 1 - a, t = n - e, i = 0;
  return t < 1 && (i = (n - t) / (1 - t)), [r[0], t * 100, i * 100];
};
u.apple.rgb = function(r) {
  return [r[0] / 65535 * 255, r[1] / 65535 * 255, r[2] / 65535 * 255];
};
u.rgb.apple = function(r) {
  return [r[0] / 255 * 65535, r[1] / 255 * 65535, r[2] / 255 * 65535];
};
u.gray.rgb = function(r) {
  return [r[0] / 100 * 255, r[0] / 100 * 255, r[0] / 100 * 255];
};
u.gray.hsl = u.gray.hsv = function(r) {
  return [0, 0, r[0]];
};
u.gray.hwb = function(r) {
  return [0, 100, r[0]];
};
u.gray.cmyk = function(r) {
  return [0, 0, 0, r[0]];
};
u.gray.lab = function(r) {
  return [r[0], 0, 0];
};
u.gray.hex = function(r) {
  var e = Math.round(r[0] / 100 * 255) & 255, a = (e << 16) + (e << 8) + e, n = a.toString(16).toUpperCase();
  return "000000".substring(n.length) + n;
};
u.rgb.gray = function(r) {
  var e = (r[0] + r[1] + r[2]) / 3;
  return [e / 255 * 100];
};
var lr = ir.exports, P = lr;
function Or() {
  for (var r = {}, e = Object.keys(P), a = e.length, n = 0; n < a; n++)
    r[e[n]] = {
      // http://jsperf.com/1-vs-infinity
      // micro-opt, but this is simple.
      distance: -1,
      parent: null
    };
  return r;
}
function Lr(r) {
  var e = Or(), a = [r];
  for (e[r].distance = 0; a.length; )
    for (var n = a.pop(), t = Object.keys(P[n]), i = t.length, o = 0; o < i; o++) {
      var s = t[o], l = e[s];
      l.distance === -1 && (l.distance = e[n].distance + 1, l.parent = n, a.unshift(s));
    }
  return e;
}
function Cr(r, e) {
  return function(a) {
    return e(r(a));
  };
}
function Gr(r, e) {
  for (var a = [e[r].parent, r], n = P[e[r].parent][r], t = e[r].parent; e[t].parent; )
    a.unshift(e[t].parent), n = Cr(P[e[t].parent][t], n), t = e[t].parent;
  return n.conversion = a, n;
}
var Br = function(r) {
  for (var e = Lr(r), a = {}, n = Object.keys(e), t = n.length, i = 0; i < t; i++) {
    var o = n[i], s = e[o];
    s.parent !== null && (a[o] = Gr(o, e));
  }
  return a;
}, K = lr, Dr = Br, O = {}, Pr = Object.keys(K);
function Ar(r) {
  var e = function(a) {
    return a == null ? a : (arguments.length > 1 && (a = Array.prototype.slice.call(arguments)), r(a));
  };
  return "conversion" in r && (e.conversion = r.conversion), e;
}
function zr(r) {
  var e = function(a) {
    if (a == null)
      return a;
    arguments.length > 1 && (a = Array.prototype.slice.call(arguments));
    var n = r(a);
    if (typeof n == "object")
      for (var t = n.length, i = 0; i < t; i++)
        n[i] = Math.round(n[i]);
    return n;
  };
  return "conversion" in r && (e.conversion = r.conversion), e;
}
Pr.forEach(function(r) {
  O[r] = {}, Object.defineProperty(O[r], "channels", { value: K[r].channels }), Object.defineProperty(O[r], "labels", { value: K[r].labels });
  var e = Dr(r), a = Object.keys(e);
  a.forEach(function(n) {
    var t = e[n];
    O[r][n] = zr(t), O[r][n].raw = Ar(t);
  });
});
var Er = O, L = _r, m = Er, J = [].slice, ur = [
  // to be honest, I don't really feel like keyword belongs in color convert, but eh.
  "keyword",
  // gray conflicts with some method names, and has its own method defined.
  "gray",
  // shouldn't really be in color-convert either...
  "hex"
], Y = {};
Object.keys(m).forEach(function(r) {
  Y[J.call(m[r].labels).sort().join("")] = r;
});
var A = {};
function b(r, e) {
  if (!(this instanceof b))
    return new b(r, e);
  if (e && e in ur && (e = null), e && !(e in m))
    throw new Error("Unknown model: " + e);
  var a, n;
  if (r == null)
    this.model = "rgb", this.color = [0, 0, 0], this.valpha = 1;
  else if (r instanceof b)
    this.model = r.model, this.color = r.color.slice(), this.valpha = r.valpha;
  else if (typeof r == "string") {
    var t = L.get(r);
    if (t === null)
      throw new Error("Unable to parse color from string: " + r);
    this.model = t.model, n = m[this.model].channels, this.color = t.value.slice(0, n), this.valpha = typeof t.value[n] == "number" ? t.value[n] : 1;
  } else if (r.length) {
    this.model = e || "rgb", n = m[this.model].channels;
    var i = J.call(r, 0, n);
    this.color = j(i, n), this.valpha = typeof r[n] == "number" ? r[n] : 1;
  } else if (typeof r == "number")
    r &= 16777215, this.model = "rgb", this.color = [
      r >> 16 & 255,
      r >> 8 & 255,
      r & 255
    ], this.valpha = 1;
  else {
    this.valpha = 1;
    var o = Object.keys(r);
    "alpha" in r && (o.splice(o.indexOf("alpha"), 1), this.valpha = typeof r.alpha == "number" ? r.alpha : 0);
    var s = o.sort().join("");
    if (!(s in Y))
      throw new Error("Unable to parse color from object: " + JSON.stringify(r));
    this.model = Y[s];
    var l = m[this.model].labels, h = [];
    for (a = 0; a < l.length; a++)
      h.push(r[l[a]]);
    this.color = j(h);
  }
  if (A[this.model])
    for (n = m[this.model].channels, a = 0; a < n; a++) {
      var f = A[this.model][a];
      f && (this.color[a] = f(this.color[a]));
    }
  this.valpha = Math.max(0, Math.min(1, this.valpha)), Object.freeze && Object.freeze(this);
}
b.prototype = {
  toString: function() {
    return this.string();
  },
  toJSON: function() {
    return this[this.model]();
  },
  string: function(r) {
    var e = this.model in L.to ? this : this.rgb();
    e = e.round(typeof r == "number" ? r : 1);
    var a = e.valpha === 1 ? e.color : e.color.concat(this.valpha);
    return L.to[e.model](a);
  },
  percentString: function(r) {
    var e = this.rgb().round(typeof r == "number" ? r : 1), a = e.valpha === 1 ? e.color : e.color.concat(this.valpha);
    return L.to.rgb.percent(a);
  },
  array: function() {
    return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
  },
  object: function() {
    for (var r = {}, e = m[this.model].channels, a = m[this.model].labels, n = 0; n < e; n++)
      r[a[n]] = this.color[n];
    return this.valpha !== 1 && (r.alpha = this.valpha), r;
  },
  unitArray: function() {
    var r = this.rgb().color;
    return r[0] /= 255, r[1] /= 255, r[2] /= 255, this.valpha !== 1 && r.push(this.valpha), r;
  },
  unitObject: function() {
    var r = this.rgb().object();
    return r.r /= 255, r.g /= 255, r.b /= 255, this.valpha !== 1 && (r.alpha = this.valpha), r;
  },
  round: function(r) {
    return r = Math.max(r || 0, 0), new b(this.color.map(qr(r)).concat(this.valpha), this.model);
  },
  alpha: function(r) {
    return arguments.length ? new b(this.color.concat(Math.max(0, Math.min(1, r))), this.model) : this.valpha;
  },
  // rgb
  red: v("rgb", 0, p(255)),
  green: v("rgb", 1, p(255)),
  blue: v("rgb", 2, p(255)),
  hue: v(["hsl", "hsv", "hsl", "hwb", "hcg"], 0, function(r) {
    return (r % 360 + 360) % 360;
  }),
  // eslint-disable-line brace-style
  saturationl: v("hsl", 1, p(100)),
  lightness: v("hsl", 2, p(100)),
  saturationv: v("hsv", 1, p(100)),
  value: v("hsv", 2, p(100)),
  chroma: v("hcg", 1, p(100)),
  gray: v("hcg", 2, p(100)),
  white: v("hwb", 1, p(100)),
  wblack: v("hwb", 2, p(100)),
  cyan: v("cmyk", 0, p(100)),
  magenta: v("cmyk", 1, p(100)),
  yellow: v("cmyk", 2, p(100)),
  black: v("cmyk", 3, p(100)),
  x: v("xyz", 0, p(100)),
  y: v("xyz", 1, p(100)),
  z: v("xyz", 2, p(100)),
  l: v("lab", 0, p(100)),
  a: v("lab", 1),
  b: v("lab", 2),
  keyword: function(r) {
    return arguments.length ? new b(r) : m[this.model].keyword(this.color);
  },
  hex: function(r) {
    return arguments.length ? new b(r) : L.to.hex(this.rgb().round().color);
  },
  rgbNumber: function() {
    var r = this.rgb().color;
    return (r[0] & 255) << 16 | (r[1] & 255) << 8 | r[2] & 255;
  },
  luminosity: function() {
    for (var r = this.rgb().color, e = [], a = 0; a < r.length; a++) {
      var n = r[a] / 255;
      e[a] = n <= 0.03928 ? n / 12.92 : Math.pow((n + 0.055) / 1.055, 2.4);
    }
    return 0.2126 * e[0] + 0.7152 * e[1] + 0.0722 * e[2];
  },
  contrast: function(r) {
    var e = this.luminosity(), a = r.luminosity();
    return e > a ? (e + 0.05) / (a + 0.05) : (a + 0.05) / (e + 0.05);
  },
  level: function(r) {
    var e = this.contrast(r);
    return e >= 7.1 ? "AAA" : e >= 4.5 ? "AA" : "";
  },
  isDark: function() {
    var r = this.rgb().color, e = (r[0] * 299 + r[1] * 587 + r[2] * 114) / 1e3;
    return e < 128;
  },
  isLight: function() {
    return !this.isDark();
  },
  negate: function() {
    for (var r = this.rgb(), e = 0; e < 3; e++)
      r.color[e] = 255 - r.color[e];
    return r;
  },
  lighten: function(r) {
    var e = this.hsl();
    return e.color[2] += e.color[2] * r, e;
  },
  darken: function(r) {
    var e = this.hsl();
    return e.color[2] -= e.color[2] * r, e;
  },
  saturate: function(r) {
    var e = this.hsl();
    return e.color[1] += e.color[1] * r, e;
  },
  desaturate: function(r) {
    var e = this.hsl();
    return e.color[1] -= e.color[1] * r, e;
  },
  whiten: function(r) {
    var e = this.hwb();
    return e.color[1] += e.color[1] * r, e;
  },
  blacken: function(r) {
    var e = this.hwb();
    return e.color[2] += e.color[2] * r, e;
  },
  grayscale: function() {
    var r = this.rgb().color, e = r[0] * 0.3 + r[1] * 0.59 + r[2] * 0.11;
    return b.rgb(e, e, e);
  },
  fade: function(r) {
    return this.alpha(this.valpha - this.valpha * r);
  },
  opaquer: function(r) {
    return this.alpha(this.valpha + this.valpha * r);
  },
  rotate: function(r) {
    var e = this.hsl(), a = e.color[0];
    return a = (a + r) % 360, a = a < 0 ? 360 + a : a, e.color[0] = a, e;
  },
  mix: function(r, e) {
    if (!r || !r.rgb)
      throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof r);
    var a = r.rgb(), n = this.rgb(), t = e === void 0 ? 0.5 : e, i = 2 * t - 1, o = a.alpha() - n.alpha(), s = ((i * o === -1 ? i : (i + o) / (1 + i * o)) + 1) / 2, l = 1 - s;
    return b.rgb(
      s * a.red() + l * n.red(),
      s * a.green() + l * n.green(),
      s * a.blue() + l * n.blue(),
      a.alpha() * t + n.alpha() * (1 - t)
    );
  }
};
Object.keys(m).forEach(function(r) {
  if (ur.indexOf(r) === -1) {
    var e = m[r].channels;
    b.prototype[r] = function() {
      if (this.model === r)
        return new b(this);
      if (arguments.length)
        return new b(arguments, r);
      var a = typeof arguments[e] == "number" ? e : this.valpha;
      return new b(Tr(m[this.model][r].raw(this.color)).concat(a), r);
    }, b[r] = function(a) {
      return typeof a == "number" && (a = j(J.call(arguments), e)), new b(a, r);
    };
  }
});
function Ir(r, e) {
  return Number(r.toFixed(e));
}
function qr(r) {
  return function(e) {
    return Ir(e, r);
  };
}
function v(r, e, a) {
  return r = Array.isArray(r) ? r : [r], r.forEach(function(n) {
    (A[n] || (A[n] = []))[e] = a;
  }), r = r[0], function(n) {
    var t;
    return arguments.length ? (a && (n = a(n)), t = this[r](), t.color[e] = n, t) : (t = this[r]().color[e], a && (t = a(t)), t);
  };
}
function p(r) {
  return function(e) {
    return Math.max(0, Math.min(r, e));
  };
}
function Tr(r) {
  return Array.isArray(r) ? r : [r];
}
function j(r, e) {
  for (var a = 0; a < e; a++)
    typeof r[a] != "number" && (r[a] = 0);
  return r;
}
var Rr = b;
const Nr = /* @__PURE__ */ rr(Rr);
const Hr = (r, e) => {
  const a = r.__vccOpts || r;
  for (const [n, t] of e)
    a[n] = t;
  return a;
}, Vr = ["success", "warning", "error", "info", "loading"], Wr = {
  success: "#A5DC86",
  warning: "#F8BB86",
  error: "#F27474",
  info: "#59BDED",
  loading: "#758BE2"
}, Ur = {
  name: "sweetalert-icon",
  props: {
    icon: {
      type: String,
      default: "success",
      validator: (r) => Vr.indexOf(r) !== -1
    },
    color: {
      type: String,
      validator: X
    }
  },
  computed: {
    cssVars() {
      const r = X(this.color) ? this.color : Wr[this.icon];
      return {
        "--icon-color": r,
        "--icon-color-alpha": Nr(r).alpha(0.25)
      };
    }
  },
  methods: {
    isIcon(r) {
      return r === this.icon;
    }
  }
}, x = (r) => (pr("data-v-82d6d3fd"), r = r(), br(), r), Kr = {
  key: 0,
  class: "sa-error"
}, Yr = /* @__PURE__ */ gr('<div class="sa-error-x" data-v-82d6d3fd><div class="sa-error-left" data-v-82d6d3fd></div><div class="sa-error-right" data-v-82d6d3fd></div></div><div class="sa-error-placeholder" data-v-82d6d3fd></div><div class="sa-error-fix" data-v-82d6d3fd></div>', 3), jr = [
  Yr
], Jr = {
  key: 1,
  class: "sa-warning"
}, Qr = /* @__PURE__ */ x(() => /* @__PURE__ */ M("div", { class: "sa-warning-body" }, null, -1)), Xr = /* @__PURE__ */ x(() => /* @__PURE__ */ M("div", { class: "sa-warning-dot" }, null, -1)), Zr = [
  Qr,
  Xr
], re = {
  key: 2,
  class: "sa-info"
}, ee = /* @__PURE__ */ x(() => /* @__PURE__ */ M("div", { class: "sa-info-body" }, null, -1)), ae = /* @__PURE__ */ x(() => /* @__PURE__ */ M("div", { class: "sa-info-dot" }, null, -1)), ne = [
  ee,
  ae
], te = {
  key: 3,
  class: "sa-loading"
}, oe = /* @__PURE__ */ x(() => /* @__PURE__ */ M("div", { class: "sa-loading-body" }, null, -1)), ie = [
  oe
], se = {
  key: 4,
  class: "sa-success"
}, le = /* @__PURE__ */ x(() => /* @__PURE__ */ M("div", { class: "sa-success-tip" }, null, -1)), ue = /* @__PURE__ */ x(() => /* @__PURE__ */ M("div", { class: "sa-success-long" }, null, -1)), ce = /* @__PURE__ */ x(() => /* @__PURE__ */ M("div", { class: "sa-success-placeholder" }, null, -1)), he = /* @__PURE__ */ x(() => /* @__PURE__ */ M("div", { class: "sa-success-fix" }, null, -1)), ve = [
  le,
  ue,
  ce,
  he
];
function fe(r, e, a, n, t, i) {
  return $(), F("div", {
    class: "sa",
    style: dr(i.cssVars)
  }, [
    i.isIcon("error") ? ($(), F("div", Kr, jr)) : i.isIcon("warning") ? ($(), F("div", Jr, Zr)) : i.isIcon("info") ? ($(), F("div", re, ne)) : i.isIcon("loading") ? ($(), F("div", te, ie)) : ($(), F("div", se, ve))
  ], 4);
}
const cr = /* @__PURE__ */ Hr(Ur, [["render", fe], ["__scopeId", "data-v-82d6d3fd"]]);
function z(r) {
  z.installed || (z.installed = !0, r.component("SweetalertIcon", cr));
}
const de = {
  install: z
};
let E = null;
typeof window < "u" ? E = window.Vue : typeof global < "u" && (E = global.Vue);
E && E.use(de);
cr.install = z;
export {
  cr as SweetalertIcon,
  cr as default
};
